import { css, keyframes } from 'styled-components';
import transition from '@geraldcloudnine/styled-transition-group';
import { animation } from './variables';

const ImageZoom = keyframes`
  from {
    transform: scale(1)
  }

  to {
    transform: scale(1.2)
  }
`;

export const ImageZoomAnimation = () => css`
  animation: ${ImageZoom} 25s ease-out 1;
  animation-fill-mode: forwards;
`;

export const SlideIn = transition.div.attrs({
  unmountOnExit: true,
  timeout: 400
})`
  &:enter { transform: translateX(${props => props.translateX}); }
  &:enter-active {
    transform: translateX(0);
    transition: transform ${props => props.transitionTime} ${props => props.easing};
  }
  &:exit { transform: translateX(0); }
  &:exit-active {
    transform: translateX(${props => props.translateX});
    transition: transform ${props => props.transitionTime} ${props => props.easing};
  }
`;

SlideIn.defaultProps = {
  translateX: '100%',
  transitionTime: '400ms',
  easing: 'ease-in-out'
};

export const FadeIn = transition.div.attrs({
  unmountOnExit: true,
  timeout: 400
})`
  &:enter { opacity: 0.01; }
  &:enter-active {
    opacity: 1;
    transition: opacity ${props => props.transitionTime} ${props => props.easing};
  }
  &:exit { opacity: 1; }
  &:exit-active {
    opacity: 0.01;
    transition: opacity ${props => props.transitionTime} ${props => props.easing};
  }
`;

FadeIn.defaultProps = {
  transitionTime: '400ms',
  easing: 'ease-in-out'
};

export const MagicGetaway = transition.div.attrs({
  mountOnEnter: true,
  unmountOnExit: true,
  timeout: 400
})`
  max-height: 250px;
  overflow:hidden;

  &:enter {
    opacity: 0.01;
    max-height: 1px;
  }
  &:enter-active {
    opacity: 1;
    max-height: 250px;
    transition: opacity .4s ease-in-out, max-height .4s ease-in-out;
  }
  &:exit {
    opacity: 1;
    max-height: 250px;
  }
  &:exit-active {
    opacity: 0.01;
    max-height: 1px;
    transition: opacity .4s ease-in-out, max-height .4s ease-in-out;
  }
  ${props =>
    props.numberOfOptions &&
    css`
      max-height: ${250 + 100 * props.numberOfOptions}px;
      &:enter-active,
      &:exit {
        max-height: ${250 + 100 * props.numberOfOptions}px;
      }
    `}
`;

MagicGetaway.defaultProps = {
  transitionTime: animation.transitionTime,
  easing: animation.easing
};

export const FadeInInline = transition.div.attrs({
  timeout: 250
})`
  display: inline-block;

  &:enter {
    opacity: 0.01;
    transform: translateY(-50%);
  }
  &:enter-active {
    opacity: 1;
    transform: translateY(0);
    transition: all .25s ease-out;
  }
  &:exit {
    opacity: 1;
    transform: translateY(0);
  }
  &:exit-active {
    opacity: 0.01;
    transform: translateY(50%);
    transition: all .25s ease-out;
  }
`;

export const FadeInInline2 = transition.div.attrs({
  timeout: 250
})`
  display: inline-block;

  &:enter {
    opacity: 0.01;
  }
  &:enter-active {
    opacity: 1;
    transition: opacity .25s ease-out;
  }
  &:exit {
    opacity: 1;
  }
  &:exit-active {
    opacity: 0.01;
    transition: opacity .25s ease-out;
  }
`;

export const DynamicBackgroundFade = transition.div.attrs({
  mountOnEnter: true,
  unmountOnExit: true,
  timeout: 400
})`
  &:enter {
    opacity: 0.01;
  }
  &:enter-active {
    opacity: 1;
    transition: opacity .4s linear;
  }
  &:exit {
    opacity: 1;
  }
  &:exit-active {
    opacity: 0.01;
    transition: opacity .4s linear;
  }
`;

export const FadeInOut = transition.div.attrs({
  mountOnEnter: true,
  unmountOnExit: true,
  timeout: 250
})`
  &:enter {
    opacity: 0.01;
  }
  &:enter-active {
    opacity: 1;
    transition: opacity 250ms ease-out;
  }
  &:exit {
    opacity: 1;
  }
  &:exit-active {
    opacity: 0.01;
    transition: opacity 250ms ease-out;
  }

  ${props =>
    props.big &&
    css`
      flex: 1;
      height: 100%;
    `}
`;

FadeInOut.defaultProps = {
  transitionTime: animation.transitionTime,
  easing: animation.easing
};



// WEBPACK FOOTER //
// ./src/styles/helpers/animations.js